import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { App, URLOpenListenerEvent } from "@capacitor/app";

const AppUrlListener: React.FC<any> = () => {
  let history = useHistory();

  useEffect(() => {
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      // OAuth / MSAL callbacks are handled by the auth flow, not routed here.
      if (
        event.url.startsWith("com.aptean.eam://oauth/auth") ||
        event.url.startsWith("msauth.com.aptean.eam://auth")
      ) {
        return;
      }
      // Universal Link / App Link (e.g. a shared work-order deep link,
      // {host}/workorder/{id}/details): route to the URL's path so the app
      // opens directly on that screen. Parse via URL so it works regardless of
      // the host's TLD (the old split(".com") broke on non-.com hosts).
      let slug: string | undefined;
      try {
        const parsed = new URL(event.url);
        slug = `${parsed.pathname}${parsed.search}`;
      } catch {
        // Fallback for non-standard URLs: take everything after the host.
        slug = event.url.split(".com").pop();
      }
      console.log("App URL Listener - SLUG: ", slug);
      if (slug && slug !== "/") {
        history.push(slug);
      }
      // If no usable path, do nothing - let regular routing logic take over
    });
  }, [history]);

  return null;
};

export default AppUrlListener;
